var Background = /** @class */ (function () {
    function Background(param) {
        var _this = this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return;
        }
        var keys = 'color';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
    }
    Background.prototype.toJSON = function () {
        return {
            "color": this.color
        };
    };
    Background.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Background;
}());
export { Background };
//# sourceMappingURL=background.js.map